import { render, staticRenderFns } from "./DepositWithdraw.vue?vue&type=template&id=5b6c2fa8&scoped=true&"
import script from "./DepositWithdraw.vue?vue&type=script&lang=js&"
export * from "./DepositWithdraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6c2fa8",
  null
  
)

export default component.exports